(function () {
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const rows = document.querySelectorAll(".th-scroll-gsap-title-wrapper");
    rows.forEach(row => {
      const fill = row.querySelector(".th-scroll-gsap-title-fill");

      gsap.fromTo(fill,
        { backgroundSize: "0% 100%, 35% 100%" },
        {
          backgroundSize: "100% 100%, 35% 100%",
          ease: "none",
          scrollTrigger: {
            trigger: row,
            start: "top 100%",
            end: "bottom 20%",
            scrub: true,
            markers: false
          }
        }
      );
    });

    // Refresh on font load
    if (document.fonts?.ready) document.fonts.ready.then(() => ScrollTrigger.refresh());
  });
})();